import { createSlice } from '@reduxjs/toolkit';
import { interactiveStart } from '../../actions/actions';
import { displayQueue } from './displayQueue';
import { fetchHistory } from './actions';

export const { actions, reducer } = createSlice({
  name: 'emoji/history',
  initialState: [],
  reducers: {
    appendChunk,
    appendRecords,
  },
  extraReducers: {
    [interactiveStart]() {
      return [];
    },
    /*
     в настоящий момент при stop происходит полная очистка истории
     этот редюсер будет иметь смысл только после исправления
     отправки stop при перемотке
    */
    [displayQueue.actions.send]: onSend,
    [fetchHistory.pending]: scheduleFetch,
    [fetchHistory.fulfilled]: fetchSuccess,
    [fetchHistory.rejected]: fetchFailure,
    // [scheduleInvalidateChunk.fulfilled]: invalidateChunk
  },
});

function appendChunk(state, action) {
  return state.concat(action.payload);
}

function appendRecords(state, action) {
  action.payload.forEach((record) => {
    const chunk = state.find(byChunkBound, record.chunk);
    if (!chunk) {
      record.emoji.forEach((emoji) => {
        record.chunk.results.push({
          start_time: record.start_time,
          ...emoji,
        });
      });
      state.push(record.chunk);
    } else {
      chunk.results ??= [];
      record.emoji.forEach((emoji) => {
        chunk.results.push({
          start_time: record.start_time,
          ...emoji,
        });
      });
    }
  });
}

function onSend(state, action) {
  const { payload: name, meta } = action;
  const chunk = state.find(byPosition, meta);

  if (!chunk) {
    /*
     any action have meta with position that sets on updateTimer
     04-mw should ensure that we have chunk
    */
    console.warn('historySlice: Missing chunk for append sent emoji');
    return;
  }

  chunk.results.push({
    name,
    count: 1,
    start_time: meta.position,
  });
}

function byPosition(chunk) {
  return this.position >= chunk.from && this.position < chunk.to;
}

function byChunkBound(chunk) {
  return this.from === chunk.from && this.to === chunk.to;
}

/**
 *
 * @param {EmojiHistoryChunk[]} state
 * @param action
 * @return {EmojiHistoryChunk[]}
 */
function scheduleFetch(chunks, action) {
  const { meta } = action;

  const existsChunk = chunks.find(({ from }) => {
    return from === meta.chunk.from;
  });

  if (existsChunk) {
    existsChunk.timestamp = meta.timestamp;
    existsChunk.requestId = meta.requestId;
    existsChunk.fetchStatus = 'pending';
  } else {
    chunks.push({
      requestId: meta.requestId,
      fetchStatus: 'pending',
      from: meta.chunk.from,
      to: meta.chunk.to,
    });
  }
  /*

    debugger;

    const chunk = state.find(byId, arg);
    if (chunk) {
      Object.assign(chunk, {
        fetchStatus: 'pending',
        requestId,
      });
    } else {
      console.warn("historySlice: Missing chunk for scheduled fetch. Chunk must be before any other operation");
    }
  */
}

/**
 * @param {EmojiHistoryChunk[]} state
 * @param {{type: string, payload: {data: Object}}} action
 * @return {EmojiHistoryChunk[]}
 */
function fetchSuccess(state, action) {
  const {
    meta,
    payload: { results },
  } = action;

  const chunk = state.find(byRequestId, meta);

  if (chunk) {
    Object.assign(chunk, {
      fetchStatus: 'success',
      timestamp: meta.timestamp,
      /*
            from: meta.chunk.from,
            to: meta.chunk.to,
      */
      results: results
        .filter(({ type }) => type === 'emoji')
        .map(({ data }) => data),
    });
  }
}

/**
 * @param {EmojiHistoryChunk[]} state
 * @param {{type: string, payload: {data: Object}, meta: {requestId: string}}} action
 * @return {EmojiHistoryChunk[]}
 */
function fetchFailure(state, action) {
  const chunk = state.find(byRequestId, action.meta);

  if (chunk) {
    chunk.timestamp = action.meta.timestamp;
    chunk.fetchStatus = 'failure';
  }
}

/**
 * @typedef {Object} InvalidateAction
 * @property {string} type
 * @property {string} payload requestId
 */

function byRequestId(chunk) {
  return chunk.requestId === this.requestId;
}
